var App = App || {};

App.Base = (function ($) {
    'use strict';

    function init() {
        Animations();
        BootstrapTabs();
        BootstrapTooltips();
        HashSupport();
        SetSplideDefaults();
        ZagParallax();
    }

    function Animations() {
        var isPreviewMode = $("body").hasClass("is-preview-mode"),
            supportsCssVariables = window.CSS && window.CSS.supports && window.CSS.supports("color", "var(--primary)"),
            itemQueue = [],
            delay = 50,
            queueTimer;

        function processItemQueue() {
            if (queueTimer) {
                return;
            }

            queueTimer = window.setInterval(function () {
                if (itemQueue.length) {
                    var animation = $(itemQueue).data("animation");

                    if (animation) {
                        $(itemQueue.shift())
                            .addClass("animate__" + animation)
                            .css("opacity", "1");

                        processItemQueue();
                    }

                } else {
                    window.clearInterval(queueTimer);

                    queueTimer = null;
                }
            }, delay);
        };

        if (supportsCssVariables && !isPreviewMode) {
            $("body").addClass("supports-css-variables");

            setTimeout(function () {
                var $elements = $("[data-animation]");

                if ($elements.length) {
                    $elements.waypoint({
                        handler: function (direction) {
                            itemQueue.push(this.element);

                            processItemQueue();
                        },
                        offset: "100%"
                    });
                }
            }, 1);
        } else {
            setTimeout(function () {
                var $elements = $("[data-animation]");

                if ($elements.length) {
                    $.each($elements, function () {
                        $(this)
                            .css({
                                "opacity": "1",
                                "z-index": 0
                            })
                            .removeAttr("data-animation")
                            .removeClass("animate__animated");
                    });
                }
            }, 1)
        }
    }

    function BootstrapTabs() {
        const tabTriggerList = document.querySelectorAll('button[data-bs-toggle="tab"]');

        tabTriggerList.forEach(triggerEl => {
            triggerEl.addEventListener("show.bs.tab", event => {
                ZagParallax();
            });
        });
    }

    function BootstrapTooltips() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
    }

    function HashSupport() {

        const Hash = $(location.hash);

        if (Hash.length == 1) {

            if (Hash.attr("data-bs-toggle") == "collapse") {
                const Target = $(Hash.attr("data-bs-target"));
                const Panel = document.getElementById(Target.attr("id"));
                const Collapse = new bootstrap.Collapse(Panel);
                Collapse.show();
            }

            else if (Hash.attr("data-bs-toggle") == "tab") {
                const Tab = new bootstrap.Tab(Hash);
                Tab.show();
            }

            else if (Hash.hasClass("modal")) {
                const Modal = new bootstrap.Modal(Hash);
                Modal.show();
            }
        }
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function SetSplideDefaults() {
        Splide.defaults = {
            mediaQuery: "min",
            speed: 600,
            trimSpace: false
        }
    }

    function ZagParallax() {
        var Selectors = [
            ".block-circular-promo",
            ".block-tabs.has-background",
            ".page-masthead",
            ".site-footer"
        ];

        $(Selectors.join(",")).each(function () {
            var $this = $(this),
                divisor = $this.data("divisor");

            if (divisor == undefined) {
                divisor = 3;
            }

            $(this).ZagParallax({ divisor: divisor });
        });
    }

    return {
        init: init,
        GetUrlParameter: GetUrlParameter
    };

})(jQuery);

$(function () {
    App.Base.init();
});